import React, { useState } from 'react';
import styled from 'styled-components';
import SectionHeader from './SectionHeader';
import CustomerBio from './CustomerBio';
import { ContentExpander } from '@clatter/ui';
import BioDetailsDialog from './BioDetailsDialog';

const StyledCustomerTeam = styled.div`
  padding: 32px 0;

  .team {
    padding: 32px 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    column-gap: 24px;
    row-gap: 48px;
    align-items: end;
  }
`;

const CustomerTeam = ({ bios, customerName, headerText = '' }) => {
  const [previewBio, setPreviewBio] = useState(null);

  const togglePreviewBio = (event) => {
    const clickedItemId = event?.currentTarget?.dataset?.id;

    if (!clickedItemId) {
      setPreviewBio(null);
    }

    const nextPreviewBio = bios.find(({ id }) => id === clickedItemId);

    setPreviewBio(nextPreviewBio);
  };

  return (
    <StyledCustomerTeam>
      <SectionHeader as="h2">
        {headerText || `${customerName} Team`}
      </SectionHeader>
      <ContentExpander
        limit={4}
        items={bios}
        moreText="More bios"
        lessText="Less bios"
      >
        {(items) => (
          <div className="team">
            {items.map((bio) => (
              <CustomerBio
                data-id={bio.id}
                data-bio-name={`${bio.displayName}, ${bio.title}`}
                key={bio.displayName}
                image={bio.profilePicture?.formats?.thumbnail?.url}
                name={bio.displayName}
                onClick={togglePreviewBio}
                onClickText="Click for Bio"
                title={bio.title}
              />
            ))}
          </div>
        )}
      </ContentExpander>
      <BioDetailsDialog
        onCloseDialog={togglePreviewBio}
        details={previewBio}
        open={!!previewBio}
      />
    </StyledCustomerTeam>
  );
};

export default CustomerTeam;
